/* Wellefex interaction layer — scroll reveals with stagger + count-up
   numbers, no dependencies. Elements opt in via [data-wfx-reveal];
   [data-wfx-reveal-group] staggers its children. The hidden state is a
   class applied BY this script only to elements it will reveal later, so
   content is never hidden without JS and never under reduced motion.
   Reveals are driven by IntersectionObserver with a rAF-throttled
   scroll-position fallback, so content can never stay hidden. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  var pendingReveal = [];
  var pendingCount = [];

  function inView(el, factor) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * (factor || 0.92) && r.bottom > 0;
  }

  function reveal(el) {
    el.classList.add('wfx-inview');
    var i = pendingReveal.indexOf(el);
    if (i > -1) pendingReveal.splice(i, 1);
  }

  var fmt = function (n) { return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  function runCounter(el) {
    var i = pendingCount.indexOf(el);
    if (i > -1) pendingCount.splice(i, 1); else return;
    var target = parseInt(String(el.getAttribute('data-wfx-count')).replace(/[^0-9]/g, ''), 10) || 0;
    var start = null;
    var dur = 1100;
    function tick(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          io.unobserve(entry.target);
          if (entry.target.hasAttribute('data-wfx-count')) runCounter(entry.target);
          else reveal(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
  }

  function prepare(el, delayMs) {
    if (el.classList.contains('wfx-pre') || el.classList.contains('wfx-inview')) return;
    if (inView(el)) return; // visible on load — never hide it
    el.style.transitionDelay = (delayMs || 0) + 'ms';
    el.classList.add('wfx-pre');
    pendingReveal.push(el);
    if (io) io.observe(el);
  }

  /* Fallback sweep — reveals anything the observer missed */
  var sweepQueued = false;
  function sweep() {
    sweepQueued = false;
    for (var i = pendingReveal.length - 1; i >= 0; i--) {
      if (inView(pendingReveal[i], 0.94)) reveal(pendingReveal[i]);
    }
    for (var j = pendingCount.length - 1; j >= 0; j--) {
      if (inView(pendingCount[j], 0.9)) runCounter(pendingCount[j]);
    }
  }
  function queueSweep() {
    if (!sweepQueued) {
      sweepQueued = true;
      requestAnimationFrame(sweep);
    }
  }
  window.addEventListener('scroll', queueSweep, { passive: true });
  window.addEventListener('resize', queueSweep, { passive: true });

  function boot() {
    document.querySelectorAll('[data-wfx-reveal]').forEach(function (el) {
      if (!el.closest('[data-wfx-reveal-group]')) prepare(el, 0);
    });
    document.querySelectorAll('[data-wfx-reveal-group]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        prepare(child, Math.min(i * 90, 540));
      });
    });
    document.querySelectorAll('[data-wfx-count]').forEach(function (el) {
      if (pendingCount.indexOf(el) === -1 && !el.hasAttribute('data-wfx-counted')) {
        el.setAttribute('data-wfx-counted', '');
        pendingCount.push(el);
        if (io) io.observe(el);
      }
    });
    queueSweep();
    /* Safety net: if anything is still hidden after 6s (broken observer,
       unusual embed), reveal it rather than leave content invisible. */
    setTimeout(function () {
      pendingReveal.slice().forEach(reveal);
    }, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
